import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface LazyLoadImageProps {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
}

const LazyLoadImageComponent: React.FC<LazyLoadImageProps> = ({ src, alt, width, height, className }) => {

  return (
    <LazyLoadImage
      className={className}
      alt={alt}
      height={height}
      src={src} 
      width={width} />
  );
};

export default LazyLoadImageComponent;